export default {
  'td.nav.glance': 'Tổng quan',
  'td.nav.route': 'Lộ trình',
  'td.nav.about': 'Về hành trình này',
  'td.nav.iti': 'Từng ngày',
  'td.nav.inex': 'Bao gồm',
  'td.nav.rv': 'Đánh giá',
  'td.nav.fit': 'Phù hợp với bạn?',
  'td.nav.faq': 'FAQ',
  'td.notFound': 'Không tìm thấy tour',
  'td.backHome': 'Về trang chủ',
  'td.realJourney': 'Đây là hành trình thực tế. Còn của bạn sẽ là phiên bản của riêng bạn.',
  'td.glanceSub': '· hành trình diễn ra như thế nào',
  'td.glance.duration': 'Thời lượng',
  'td.glance.destinations': 'Điểm đến',
  'td.glance.tourPace': 'Nhịp độ tour',
  'td.glance.physicalRating': 'Mức độ thể lực',
  'td.glance.gettingAround': 'Di chuyển',
  'td.glance.bestSeason': 'Mùa đẹp nhất',
  'td.glance.indicativeFrom': 'Giá tham khảo từ',
  'td.glance.departsAnyDay': 'Khởi hành bất kỳ ngày nào, quanh năm',
  'td.glance.halong': 'Hạ Long',
  'td.glance.overland': 'Có thể chuyển sang di chuyển đường bộ nếu bạn không muốn bay',
  'td.licensed': 'Đơn vị lữ hành quốc tế được cấp phép',
  'td.route': 'Lộ trình',
  'td.about': 'Về hành trình này',
  'td.includes': 'Hành trình này bao gồm những gì',
  'td.included': 'Bao gồm',
  'td.excluded': 'Không bao gồm',
  'td.includesNote': 'Phần này mô tả hành trình như trên. Khi phiên bản của bạn được chốt, chuyên gia địa phương sẽ xác nhận bằng văn bản chính xác những gì nằm trong báo giá của bạn và những gì không, trước khi bất kỳ điều gì được thống nhất.',
  'td.reviewsTitle': 'Khách của chúng tôi nói gì',
  'td.excellent': 'Tuyệt vời trên Tripadvisor',
  'td.verifiedReviews': 'Đánh giá đã xác minh từ khách hàng Meetup Travel',
  'td.readAllReviews': 'Đọc tất cả đánh giá',
  'td.showLess': 'Thu gọn',
  'td.readMore': 'Đọc thêm',
  'td.postedOn': 'Đăng trên',
  'td.prevReview': 'Đánh giá trước',
  'td.nextReview': 'Đánh giá sau',
  'td.rightForYou': 'Đây có phải là điểm khởi đầu tốt cho bạn không?',
  'td.honestVersion': 'Phiên bản trung thực',
  'td.goodIf': 'Điểm khởi đầu tốt nếu bạn',
  'td.notIf': 'Hãy nói sớm nếu bạn',
  'td.nextStepBold': 'Bước tiếp theo cần thông tin chi tiết thực sự.',
  'td.nextStepRest': 'Ngày đi của bạn, ai sẽ đi cùng, bạn thích di chuyển thế nào, bạn muốn thay đổi điều gì ở lộ trình này. Chỉ mất vài phút để điền, bởi một chuyên gia địa phương sẽ viết lịch trình của bạn từ chính những câu trả lời đó thay vì gửi bạn một tệp có sẵn. Chưa có gì được đặt hay tính phí ở giai đoạn này.',
  'td.contactExpert': 'Liên hệ chuyên gia địa phương',
  'td.beforeContact': 'Trước khi bạn liên hệ',
  'td.related': 'Bạn có thể thích những tour này',
  'td.viewAll': 'Xem tất cả →',
  'td.from': 'Từ',
  'td.view': 'Xem',
  'td.on': 'trên',
  'td.rel1.title': 'Tour Gia đình Việt Nam - 15 ngày',
  'td.rel1.duration': '15N14Đ',
  'td.rel2.title': 'Hành trình trăng mật Việt Nam',
  'td.rel2.duration': '10N9Đ',
  'td.rel3.title': 'Miền Bắc & Miền Trung Việt Nam - 6 ngày',
  'td.rel3.duration': '6N5Đ',
  'td.rel4.title': 'Việt Nam từ Bắc vào Nam - 6 ngày',
  'td.rel4.duration': '6N5Đ',
  'td.spots': '{{count}} điểm',
  'td.license': 'Giấy phép lữ hành quốc tế',
  'td.payments': 'Visa · Mastercard · JCB · Amex · PayPal',
  'td.option3desc': 'Hành trình này, 1 người lớn, 3 sao',
  'td.option3info': 'Khách sạn 3 sao tiện nghi và du thuyền Hạ Long tiêu chuẩn. Phòng sạch sẽ, dịch vụ thân thiện và giá trị tuyệt vời cho chuyến đi một ngày thư giãn.',
  'td.option4desc': 'Hành trình này, 1 người lớn, 4 sao',
  'td.option4info': 'Khách sạn 4 sao cao cấp và du thuyền rộng rãi hơn với dịch vụ ăn uống trên tàu tốt hơn cùng sự phục vụ chu đáo.',
  'td.option5desc': 'Hành trình này, 1 người lớn, 5 sao',
  'td.option5info': 'Khách sạn 5 sao sang trọng và du thuyền cao cấp với ẩm thực tinh tế, phòng nghỉ rộng rãi và dịch vụ đỉnh cao.',
  'td.pricing.from': 'Hành trình này, từ',
  'td.pricing.perPerson': '{{currency}} / người',
  'td.pricing.planner': 'Lập kế hoạch ngân sách',
  'td.pricing.yourOption': 'Lựa chọn của bạn',
  'td.pricing.adults': 'Số người lớn',
  'td.pricing.children': 'Số trẻ em',
  'td.pricing.decreaseAdult': 'Giảm người lớn',
  'td.pricing.increaseAdult': 'Tăng người lớn',
  'td.pricing.decreaseChild': 'Giảm trẻ em',
  'td.pricing.increaseChild': 'Tăng trẻ em',
  'td.pricing.roughTotal': 'Tổng ước tính, chỉ mang tính tham khảo',
  'td.pricing.noticeTitle': 'Lưu ý quan trọng',
  'td.pricing.notice1a': 'Đây là giá cho hành trình như đã viết',
  'td.pricing.notice1b': ', không phải báo giá cho chuyến đi của bạn.',
  'td.pricing.notice2a': 'Chuyên gia địa phương sẽ tùy chỉnh chi tiết cùng bạn.',
  'td.pricing.notice2b': ' Khách sạn, du thuyền, nhịp độ và các hạng mục bao gồm được quyết định trong cuộc trò chuyện đó, và giá cuối cùng dựa trên đó.',
  'td.pricing.notice3': 'Giá thay đổi theo mùa, theo tình trạng còn chỗ và theo thời điểm bạn đi. Hãy coi con số trên chỉ là tham khảo.',
  'td.pricing.notice4': 'Giá trẻ em phụ thuộc vào độ tuổi và chiều cao, được xác nhận theo từng trường hợp.',
  'td.pricing.bookingNow': 'Đặt ngay',
  'td.pricing.removeSaved': 'Bỏ khỏi danh sách đã lưu',
  'td.pricing.saveTour': 'Lưu tour',
  'td.pricing.noCharge': 'Trang này không đặt hay tính phí bất kỳ điều gì',
  'td.pricing.cancellation': 'Chính sách hủy',
  'td.pricing.flightTitle': 'Vé máy bay & khách sạn / du thuyền',
  'td.pricing.flight1': 'Không hoàn tiền',
  'td.pricing.flight2': 'Vé có thể được giữ và dời lịch trong vòng 365 ngày',
  'td.pricing.flight3': 'Việc đổi ngày tuân theo quy định của hãng hàng không và có thể phát sinh thêm phí',
  'td.pricing.flight4': 'Việc hủy khách sạn và du thuyền tuân theo chính sách riêng của từng cơ sở',
  'td.pricing.groupTitle': 'Tour đoàn',
  'td.pricing.group1a': 'Miễn phí hủy',
  'td.pricing.group1b': ' đến 2 ngày trước khi khởi hành',
  'td.pricing.group2a': 'Phí 50%',
  'td.pricing.group2b': ' trước 6:00 PM ngày hôm trước',
  'td.pricing.group3a': 'Phí 100%',
  'td.pricing.group3b': ' sau 6:00 PM ngày hôm trước',
  'td.pricing.privateTitle': 'Tour riêng',
  'td.pricing.private1a': 'Miễn phí hủy',
  'td.pricing.private1b': ' đến 7 ngày trước khi khởi hành',
  'td.pricing.private2a': 'Phí 50%',
  'td.pricing.private2b': ' trong vòng 4 đến 7 ngày trước khi khởi hành',
  'td.pricing.private3a': 'Phí 100%',
  'td.pricing.private3b': ' trong vòng 3 ngày trước khi khởi hành',
  'td.pricing.mobileJourney': 'hành trình này · {{label}}',
  'td.day.title': 'Hành trình từng ngày',
  'td.day.collapse': 'Thu gọn tất cả',
  'td.day.expand': 'Mở rộng tất cả',
  'td.day.intro': 'Được viết theo đúng cách hành trình diễn ra, để không có gì phải phụ thuộc vào trí tưởng tượng của bạn. Hãy đọc, ghi chú những ngày bạn muốn giữ và những ngày bạn muốn bỏ, và chuyên gia địa phương sẽ điều chỉnh phần còn lại theo bạn.',
  'td.day.dayLabel': 'NGÀY {{n}}',
  'td.day.breakfast': 'Ăn sáng',
  'td.day.lunch': 'Ăn trưa',
  'td.day.dinner': 'Ăn tối',
  'td.day.viewPhoto': 'Xem ảnh',
  'td.day.openPhotoFor': 'Mở ảnh cho {{title}}',
  'td.day.openPhoto': 'Mở ảnh {{n}}',
  'td.day.close': 'Đóng',
  'td.day.previous': 'Trước',
  'td.day.next': 'Sau',
  'td.breadcrumb': 'Điều hướng',
  'td.pageSections': 'Các phần của trang',
};